import type { ChangeEvent } from 'react';
import type { UseFormSetValue } from 'react-hook-form';

import type { ICreditCardForm } from '@/modules/perseo-billing/interfaces';

export const formatCardNumber = (value: string): string => {
  return (
    value
      .replace(/\s|[^0-9]+/g, '')
      .match(/.{1,4}/g)
      ?.join(' ') ?? ''
  );
};

export const formatExpiry = (
  e: ChangeEvent<HTMLInputElement>,
  setValue: UseFormSetValue<ICreditCardForm>
) => {
  const value = e.target.value.replace(/\D+/g, '');
  let formattedValue = '';

  if (value.length > 0) {
    formattedValue = value.slice(0, 2);
  }

  if (value.length > 2) {
    formattedValue += '/' + value.slice(2);
  }

  if (formattedValue.length <= 5) {
    // restrict the input length to 5 characters (MM/YY)
    setValue('expiry', formattedValue, {
      shouldDirty: true,
      shouldValidate: true
    });
  }
};
